import React, { useState } from "react";
import AuthLayout from "../../layouts/AuthLayout";
import {
  CustomInput,
  CustomPasswordInput,
} from "../../Components/Common/CustomInput";
import { useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress, useMediaQuery } from "@mui/material";
import {
  EmailOutlined,
  LoginRounded,
  PersonOutline,
  CalendarMonth,
} from "@mui/icons-material";
import { CustomDropDown } from "../../Components/Common/CustomDropdown";
import { CustomBtn } from "../../Components/Common/CustomBtn";
import { createUser, getUserById } from "../../redux/actions/user.dispatcher";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { useDispatch } from "react-redux";
import { CustomCheckbox } from "../../Components/Common/CustomCheckbox";
import { BASE_URL } from "../../utils/config/config";
import axios from "axios";

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const smallScreen = useMediaQuery("(max-width:800px)");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState([]);

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleRegister = async () => {
    setErrorState({ error: false, message: "" });
    if (!firstName) {
      setErrorState({ error: true, message: "First Name is required" });
      return;
    }

    if (!lastName) {
      setErrorState({ error: true, message: "Last Name is required" });
      return;
    }
    if (!password) {
      setErrorState({ error: true, message: "Password is required" });
      return;
    }
    if (!email) {
      setErrorState({ error: true, message: "Email is required" });
      return;
    }
    if (!dob) {
      setErrorState({ error: true, message: "Date of birth is required." });
      return;
    }
    if (!userType[0]) {
      setErrorState({
        error: true,
        message: "Select whether you want to be a basic user or creator",
      });
      return;
    }

    const birthDate = new Date(dob);
    const today = new Date();
    const cutoffDate = new Date(
      today.getFullYear() - 16,
      today.getMonth(),
      today.getDate()
    );

    if (birthDate > cutoffDate) {
      setErrorState({
        error: true,
        message: "You must be at least 16 years old to register.",
      });
      return;
    }

    try {
      setLoading(true);

      const create = await axios.post(`${BASE_URL}/user/register`, {
        email,
        password,
        firstName,
        lastName,
        dateOfBirth: dob,
        userType: "basic",
      });

      localStorage.setItem("authToken", create.data.accessToken);

      if (create) {
        await dispatch(getUserById(create.data.user.id));
        if (userType[0] == "User") {
          navigate("/onboarding");
        } else {
          navigate("/creator/form", {
            state: {
              isFreshlyRegistered: true,
            },
          });
        }
      }
    } catch (error) {
      console.log(error, "err");
      setErrorState({ error: true, message: error.response.data.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout type="register">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomInput
        placeholder="Enter First Name"
        Icon={PersonOutline}
        value={firstName}
        setValue={setFirstName}
        label={"First Name"}
      />
      <CustomInput
        placeholder="Last Name"
        Icon={PersonOutline}
        value={lastName}
        setValue={setLastName}
        label={"Last Name"}
      />
      <CustomInput
        placeholder="Email"
        Icon={EmailOutlined}
        value={email}
        setValue={setEmail}
        label={"Email"}
      />
      <CustomInput
        placeholder="Date of Birth"
        Icon={CalendarMonth}
        value={dob}
        type={"date"}
        setValue={setDob}
        label={"Date of Birth"}
      />
      <CustomPasswordInput
        placeholder="Password"
        value={password}
        setValue={setPassword}
        label={"Password"}
      />
      <CustomCheckbox
        options={["User", "Creator"]}
        selectedValues={userType}
        onChange={setUserType}
        multiple={false} // Only one selection allowed
      />

      <CustomBtn
        text="Register"
        Icon={LoginRounded}
        width={smallScreen ? "50%" : "40%"}
        onClick={handleRegister}
      />

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </AuthLayout>
  );
};

export default Register;
